export const textPaddingLimit = 45
